import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import Loader from "react-loader-spinner";
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner.gif";

class ChangeServiceCheckoutModal extends React.Component {
  constructor(props) {
    super(props);

    let initialPage = 1
    if (props.cancelModal) {
      initialPage = 3
    } else if (props.subservices && props.previous_total != null && props.project) {
      let price = 0
      const bundleDiscounted = props.project.bundle_discounted || 0
      const discountCode = props.project.discount_code
      Object.values(props.subservices).forEach(subservice => {
        let subPrice = parseFloat(props.location_pricing?.[subservice.id]?.price || subservice.price)
        if (bundleDiscounted > 0) subPrice = Math.ceil(subPrice - subPrice * bundleDiscounted / 100)
        if (discountCode && subPrice > 0) {
          let codeDiscount = discountCode.percentage ? subPrice * discountCode.amount / 100.0 : Math.min(discountCode.amount, subPrice)
          const maxDiscount = Math.max(subPrice - props.previous_total, 0)
          codeDiscount = Math.min(Math.round(codeDiscount), maxDiscount)
          subPrice -= codeDiscount
        }
        price += subPrice
      })
      price = Math.round(price - props.previous_total)
      const isAdminOrBroker = props.client_role === "admin" || props.client_role === "broker" || props.client_role === "sub_broker"
      if (price < 0) {
        initialPage = 3
      } else if (price > 0 && !isAdminOrBroker) {
        initialPage = 2
      }
    }

    this.state = {
      page: initialPage,
      paymentInfo: {},
      createPayment: false,
      errors: [],
      current_cvc: ""
    }

    this.handleInput = this.handleInput.bind(this)
    this.createPayment = this.createPayment.bind(this)
    this.createRefund = this.createRefund.bind(this)
    this.createAccountCredit = this.createAccountCredit.bind(this)
  }


  componentDidMount() {
    document.body.style.overflow = 'hidden';
    this.props.fetchPaymentInfo(this.props.client).then(paymentInfo =>
      this.setState({ paymentInfo: paymentInfo, formerPaymentInfo: JSON.parse(JSON.stringify(paymentInfo)), createPayment: Object.values(paymentInfo).length === 0 })
    ).then(() => {
      let code = "XXXX-XXXX-XXXX-"
      let paymentInfo = this.state.paymentInfo
      let current_cvc = ""
      if (paymentInfo["last_four"]) {
        paymentInfo["last_four"] = code + paymentInfo["last_four"]
      }
      if (paymentInfo["cvc"]) {
        current_cvc = paymentInfo["cvc"]
        paymentInfo["cvc"] = paymentInfo["cvc"]?.length === 3 ? "XXX" : "XXXX"
      }

      if (paymentInfo.payment_service_id) {
        this.setState({ paymentInfo: paymentInfo, current_cvc: current_cvc })
      } else {
        this.setState({ paymentInfo: {} })
      }
    })
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  createAccountCredit() {
    if (this.props.cancelModal) {
      if (window.confirm('Are you sure you want to cancel this project?')) {
        this.setState({ page: 4 })
        this.props.createAccountCredit()
      }
    } else {
      this.setState({ page: 4 })
      this.props.createAccountCredit()
    }
  }

  createRefund() {
    if (this.props.cancelModal) {
      if (window.confirm('Are you sure you want to cancel this project?')) {
        this.setState({ page: 4 })
        this.props.createRefund()
      }
    } else {
      this.setState({ page: 4 })
      this.props.createRefund()
    }
  }

  createPayment() {
    let errors = []
    let paymentInfo = this.state.paymentInfo;
    let formerPaymentInfo = this.state.formerPaymentInfo;

    paymentInfo["user_id"] = this.props.client ? parseInt(this.props.client) : this.props.currentUser.id


    if (!paymentInfo["cardholder_name"] || paymentInfo["cardholder_name"].length === 0) {
      errors.push([0, "Name can't be blank"])
    }

    if (!paymentInfo["cvc"] || (paymentInfo["cvc"].length != 3 && paymentInfo["cvc"].length != 4)) {
      errors.push([1, "CVC code must be 3 or 4 digits long"])
    }

    if (paymentInfo["cvc"] === "XXX" || paymentInfo["cvc"] === "XXXX" || paymentInfo["cvc"] === this.state.current_cvc) {
      paymentInfo["cvc"] = this.state.current_cvc
    }

    if (!paymentInfo["last_four"] || (paymentInfo["last_four"].length != 16 && paymentInfo["last_four"].length != 15 && paymentInfo["last_four"].length != 19)) {
      errors.push([2, "Card number must be 15 or 16 digits long"])
    }

    if (paymentInfo["last_four"] && paymentInfo["last_four"][0] === "X") {
      delete paymentInfo["last_four"]
      delete formerPaymentInfo["last_four"]
    }

    if (paymentInfo["exp_month"] === "Month") {
      errors.push([3, "Expiration month is required"])
    }

    if (paymentInfo["exp_year"] === "Year") {
      errors.push([4, "Expiration year is required"])
    }

    if (errors.length === 0 && !this.state.createPayment && JSON.stringify(paymentInfo) === JSON.stringify(formerPaymentInfo)) {
      this.setState({ page: 4 })
      this.props.updateProject()
    }
    else if (errors.length === 0) {
      // if (!paymentInfo["cvc"]) {
      //   errors.push([1, "CVC code required to make changes to payment info"])
      // }

      if (!paymentInfo["last_four"]) {
        errors.push([2, "Full card number required to make changes to payment info"])
      }

      if (errors.length === 0) {
        this.props.createPayment(paymentInfo).then((payment) => {
          if (payment.errors) {
            errors.push([5, payment.errors])
            this.setState({ errors: errors })
          } else {
            this.props.updateProject()
            this.setState({ page: 4 })
          }
        })
      } else {
        this.setState({ errors: errors })
      }
    } else {
      this.setState({ errors: errors })
    }
  }

  handleInput(field) {
    return e => {
      let paymentInfo = this.state.paymentInfo

      if ((field === "cvc" || field === "last_four") && paymentInfo[field]?.length > 0 && paymentInfo[field][0] === "X") {
        if (e.currentTarget.value.length === 2 || e.currentTarget.value.length === 18) {
          paymentInfo[field] = ""
        } else {
          paymentInfo[field] = e.currentTarget.value[e.currentTarget.value.length - 1]
        }
      }
      else {
        if ((field === "cvc" && e.currentTarget.value.length > 4) || (field === "last_four" && e.currentTarget.value.length > 16)) {

        } else {
          paymentInfo[field] = e.currentTarget.value
        }
      }
      this.setState({ paymentInfo: paymentInfo });
    }
  }


  render() {
    if (this.state.page === 1) {
      let price = 0;
      let discount = 0;
      let account_credit_component = "";
      let account_credit = this.props.account_credit;
      let previous_services = {}

      this.props.previous_services.forEach(service => previous_services[service.id] = true)

      const bundleDiscounted = this.props.project.bundle_discounted || 0
      const discountCode = this.props.project.discount_code

      // First pass: calculate bundled prices and total
      let bundledPrices = {}
      let totalBundled = 0
      Object.values(this.props.subservices).forEach(subservice => {
        let p = parseFloat(this.props.location_pricing[subservice.id]?.price || subservice.price)
        if (bundleDiscounted > 0) p = Math.ceil(p - p * bundleDiscounted / 100)
        bundledPrices[subservice.id] = p
        totalBundled += p
      })

      // Calculate total code discount with cap on the aggregate
      let totalCodeDiscount = 0
      if (discountCode && totalBundled > 0) {
        let raw = discountCode.percentage
          ? totalBundled * discountCode.amount / 100.0
          : Math.min(discountCode.amount, totalBundled)
        const maxDiscount = Math.max(totalBundled - this.props.previous_total, 0)
        totalCodeDiscount = Math.min(Math.round(raw), maxDiscount)
      }

      let subServices = Object.values(this.props.subservices).map(subservice => {
        let bundledPrice = bundledPrices[subservice.id]
        let serviceDiscount = totalBundled > 0 ? Math.round(totalCodeDiscount * bundledPrice / totalBundled) : 0
        let allInPrice = bundledPrice - serviceDiscount
        price += allInPrice
        // Still selected from before (e.g. untouched while upgrading a different
        // sub-service on the same package) — nothing changed, so don't list it;
        // its price is still counted above so the total stays correct.
        if (this.props.previous_sub_services[subservice.id]) return null
        return (<div className="orderSummaryLi">
          <div className="bold">{subservice.title}</div>
          <div className="orderSummarySubservicePrice">${allInPrice.toFixed(0)}</div>
        </div>)
      }).filter(Boolean)

      Object.values(this.props.previous_sub_services).forEach(sub_service => {
        // Still selected (e.g. untouched while upgrading a different sub-service
        // on the same package) — not actually being removed, so don't list it here.
        if (this.props.subservices[sub_service.id]) return

        const removedPrice = Math.round(parseFloat(this.props.project.invoice_sub_services[sub_service.id].price))
        subServices.push(<div className="orderSummaryLi">
          <div>{sub_service.title} (removed)</div>
          <div className="orderSummarySubservicePrice promoApplied">-${removedPrice.toFixed(0)}</div>
        </div>)
      })

      price = Math.round(price - this.props.previous_total)

      if (this.props.account_credit && price > 0) {
        if (this.props.account_credit >= price) {
          account_credit = this.props.account_credit - price
          discount = this.props.account_credit - account_credit
          price = 0
        } else {
          price = price - this.props.account_credit
          discount = this.props.account_credit
          account_credit = 0
        }
      }

      if (discount > 0) {
        subServices.push(<div className="orderSummaryLi">
          <div>Account credit applied: </div>
          <div className="orderSummarySubservicePrice promoApplied">-${discount.toFixed(0)}</div>
        </div>)
      }

      let submitButton = <button className="projectEditButton projectEditButtonPrimary" onClick={() => this.setState({ page: 2 })}>Continue to payment</button>

      if (price === 0) {
        submitButton = <button className="projectEditButton projectEditButtonPrimary" onClick={() => { this.setState({ page: 4 }); this.props.updateProject() }}>Submit Changes</button>
      } else if ((this.props.client_role === "admin") || this.props.client_role === "broker" || (this.props.client_role === "sub_broker" && this.props.firm.broker_charge) || (this.props.client_role === "sub_broker" && this.props.currentUser.roles.broker)) {
        submitButton = <button className="projectEditButton projectEditButtonPrimary" onClick={() => { this.setState({ page: 4 }); this.props.updateProject() }}>Submit Order</button>
      } else if (price < 0) {
        submitButton = <button className="projectEditButton projectEditButtonPrimary" onClick={() => this.setState({ page: 3 })}>Continue to refund page</button>
      }

      return (
        <div className="modal-background" onClick={() => this.props.changeParentState({ subModal: null })}>
          <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
            <div className="orderPreviewModalComponent">
              <div className="settingsComponentHeading orderPreviewModalHeading">Order Preview</div>
              <div className="orderPreviewModalCategory">
                <div className="settingsComponentHeading">Property Details</div>
                <div className="addressPreviewModal">{this.props.formatted_address ? `${this.props.apartment} ${this.props.formatted_address}` : `${this.props.street}, ${this.props.apartment} ${this.props.city}, ${this.props.state} ${this.props.zipcode}`} </div>
              </div>
              <div className="orderPreviewModalCategory">
                <div className="settingsComponentHeading">Service Details</div>
                <div className="previewOrderListModal">
                  {subServices}
                </div>
              </div>
              <div className="orderSummaryPriceDiv">
                <div>Total: </div>
                <div>${price.toFixed(0)}</div>
              </div>
              {/* {account_credit_component} */}
              <div className="d-flex justify-content-end">
                {submitButton}
              </div>
            </div>
            <div className="modalMobilePushup"></div>
          </div>
        </div>
      )
    }
    else if (this.state.page === 2) {
      let price = 0;
      let discount = 0;
      let account_credit = this.props.account_credit;

      const bundleDiscounted = this.props.project.bundle_discounted || 0
      const discountCode = this.props.project.discount_code

      let bundledPrices = {}
      let totalBundled = 0
      Object.values(this.props.subservices).forEach(subservice => {
        let p = parseFloat(this.props.location_pricing[subservice.id]?.price || subservice.price)
        if (bundleDiscounted > 0) p = Math.ceil(p - p * bundleDiscounted / 100)
        bundledPrices[subservice.id] = p
        totalBundled += p
      })

      let totalCodeDiscount = 0
      if (discountCode && totalBundled > 0) {
        let raw = discountCode.percentage
          ? totalBundled * discountCode.amount / 100.0
          : Math.min(discountCode.amount, totalBundled)
        const maxDiscount = Math.max(totalBundled - this.props.previous_total, 0)
        totalCodeDiscount = Math.min(Math.round(raw), maxDiscount)
      }

      Object.values(this.props.subservices).forEach(subservice => {
        let bundledPrice = bundledPrices[subservice.id]
        let serviceDiscount = totalBundled > 0 ? Math.round(totalCodeDiscount * bundledPrice / totalBundled) : 0
        price += bundledPrice - serviceDiscount
      })

      price = Math.round(price - this.props.previous_total)

      if (this.props.promo_price) {
        price = this.props.promo_price - this.props.previous_total
      }

      if (this.props.account_credit && price > 0) {
        if (this.props.account_credit >= price) {
          account_credit = this.props.account_credit - price
          price = 0
          discount = this.props.account_credit - account_credit
        } else {
          price = price - this.props.account_credit
          discount = this.props.account_credit
          account_credit = 0
        }
      }

      let cardHolderNameErrorClass = "";
      let cardNumberErrorClass = "";
      let expMonthErrorClass = "";
      let expYearErrorClass = "";
      let cvcErrorClass = "";

      let cardNumberErrors = [];
      let cardHolderNameErrors = [];
      let expMonthErrors = [];
      let expYearErrors = [];
      let cvcErrors = [];
      let backendErrors = [];

      const yearOptions = [];
      let d = new Date();
      let n = d.getFullYear();
      for (let i = n; i < n + 20; i++) {
        yearOptions.push(<option key={i} value={i}>{i}</option>);
      }

      this.state.errors.forEach((error) => {

        if (error[0] === 0) {
          cardHolderNameErrors.push(<li>{error[1]}</li>)
          cardHolderNameErrorClass = "formInputError"
        }

        else if (error[0] === 1) {
          cvcErrors.push(<li>{error[1]}</li>)
          cvcErrorClass = "formInputError"
        }

        else if (error[0] === 2) {
          cardNumberErrors.push(<li>{error[1]}</li>)
          cardNumberErrorClass = "formInputError"
        }

        else if (error[0] === 3) {
          expMonthErrors.push(<li>{error[1]}</li>)
          expMonthErrorClass = "formInputError"
        }

        else if (error[0] === 4) {
          expYearErrors.push(<li>{error[1]}</li>)
          expYearErrorClass = "formInputError"
        }
        else if (error[0] === 5) {
          backendErrors.push(<li>{error[1]}</li>)
        }
      })
      return (
        <div className="modal-background" onClick={() => this.props.changeParentState({ subModal: null })}>
          <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
            <div className="orderPreviewModalComponent">
              <div className="settingsComponentHeading orderPreviewModalHeading"> Checkout </div>
              <div className="orderPreviewModalCategory">
                <div className="settingsComponentHeading">Payment Details</div>
                <ul className="errorUl backendErrorsPayment">{backendErrors}</ul>
                <div className="createProjectPaymentModal">
                  <div className="createProjectPaymentGroupings">
                    <div className="settingsCategoryGroup1">
                      <div className="inputGrouping paymentModalGrouping">
                        <div className="settingsCompanyInput paymentModalInput">
                          <label id="formLabel"> Cardholder Name </label>
                          <input className="formInput" id={cardHolderNameErrorClass} onChange={this.handleInput("cardholder_name")} type="string" placeholder="Cardholder Name" value={this.state.paymentInfo["cardholder_name"] || ""} />
                          <ul className="errorUl">{cardHolderNameErrors}</ul>
                        </div>
                        <div className="settingsCompanyInput paymentModalInput">
                          <label id="formLabel"> Card Number </label>
                          <input className="formInput" id={cardNumberErrorClass} onChange={this.handleInput("last_four")} type="string" placeholder="Card Number" value={this.state.paymentInfo["last_four"] || ""} />
                          <ul className="errorUl">{cardNumberErrors}</ul>
                        </div>
                        <div className="settingsCompanyInput paymentModalInput">
                          <label id="formLabel"> CVC </label>
                          <input className="formInput" id={cvcErrorClass} onChange={this.handleInput("cvc")} type="string" placeholder="CVC" value={this.state.paymentInfo["cvc"] || ""} />
                          <ul className="errorUl">{cvcErrors}</ul>
                        </div>
                      </div>
                      <div className="inputGrouping paymentModalGrouping">
                        <div className="settingsCompanyInput paymentModalInput">
                          <label id="formLabel"> Expiration Month</label>
                          <select className="formInput" id={expMonthErrorClass} onChange={this.handleInput("exp_month")} name="Month" value={this.state.paymentInfo["exp_month"] || "Month"} >
                            <option value="Month" disabled={true}>Month</option>
                            <option value="1">January</option>
                            <option value="2">February</option>
                            <option value="3">March</option>
                            <option value="4">April</option>
                            <option value="5">May</option>
                            <option value="6">June</option>
                            <option value="7">July</option>
                            <option value="8">August</option>
                            <option value="9">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                          </select>
                          <ul className="errorUl">{expMonthErrors}</ul>
                        </div>
                        <div className="settingsCompanyInput paymentModalInput">
                          <label id="formLabel"> Expiration Year </label>
                          <select className="formInput" id={expYearErrorClass} onChange={this.handleInput("exp_year")} name="Year" value={this.state.paymentInfo["exp_year"] || "Year"} >
                            <option value="Year" disabled={true}>Year</option>
                            {yearOptions}
                          </select>
                          <ul className="errorUl">{expYearErrors}</ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="orderSummaryPriceDiv">
                <div>Total: </div>
                <div>${price.toFixed(0)}</div>
              </div>
              <div className="d-flex justify-content-end">
                <button className="projectEditButton projectEditButtonPrimary" onClick={this.createPayment}>Submit Order</button>
              </div>
            </div>
            <div className="modalMobilePushup"></div>
          </div>
        </div>
      )


    }
    else if (this.state.page === 3) {
      let price = 0;


      Object.values(this.props.subservices).map(subservice => {
        let new_sub_service_price = parseFloat(this.props.location_pricing[subservice.id] ? this.props.location_pricing[subservice.id].price : subservice.price)
        if (Object.values(this.props.project.invoices)[0].discounted > 0) {
          new_sub_service_price -= parseInt(new_sub_service_price * (Object.values(this.props.project.invoices)[0].discounted / 100))
        }
        price += new_sub_service_price
      })

      if (this.props.promo_price) {
        price = this.props.promo_price
      }

      price = Math.round((price - this.props.previous_total) * -1)

      if (this.props.cancelModal) {
        price = this.props.previous_total*-1;
      }

      let previousSubService_ids = []

      Object.values(this.props.previous_sub_services).forEach(sub_service => previousSubService_ids.push(sub_service.id))
  
      let invoice_array = Object.values(this.props.project.invoices).filter(invoice => invoice.sub_services.includes(previousSubService_ids[0]))

      let invoice = ""

      if (invoice_array.length === 1) {
        invoice = invoice_array[0]
      }
      else {
        invoice = invoice_array[0]

        invoice_array.forEach(inv => {
          if (new Date(inv.created_at) > new Date(invoice.created_at)) {
            invoice = inv
          }
        })
      }

      return (
        <div className="modal-background" onClick={() => this.props.changeParentState({ subModal: null })}>
          <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
            <div className="orderPreviewModalComponent">
              <div className="settingsComponentHeading orderPreviewModalHeading"> Refund/Account Credit </div>
              <div className="orderPreviewModalCategory">
                <div className="settingsComponentHeading">Refund Details</div>
                <div className="refundModalBox">
                  <div className="refundModalSubTitle mb-3">Choose the option which works best for you:</div>
                  <button className="projectEditButton projectEditButtonPrimary mb-3 ms-0 w-100"
                    onClick={this.createAccountCredit} disabled={this.state.loading}>
                    Account Credit: ${Math.round(price * 1).toFixed(0)}
                  </button>
                  {invoice.total >= price && (
                    <button className="projectEditButton projectEditButtonPrimary mb-3 w-100"
                      onClick={this.createRefund} disabled={this.state.loading}>
                      Refund: ${Math.round(price * 0.95).toFixed(0)}
                    </button>
                  )}
                  <button className="projectEditButton projectEditButtonWhite w-100" onClick={() => this.props.changeParentState({ subModal: null })}>
                    I no longer wish to downgrade this service
                  </button>
                </div>
              </div>
            </div>
            <div className="modalMobilePushup"></div>
          </div>
        </div>
      )
    }
    else if (this.state.page === 4) {
      return (
        <div className="modal-background">
          <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
            <div className="orderPreviewModalComponent">
              <div className="uploadPhotoModalHeadingGroup">
                <div className="uploadPhotoModalHeading"> Checkout</div>
              </div>
              <div className="orderPreviewModalCategory">
                <div className="settingsComponentHeading">Submitting Order...</div>
                <div className="createProjectPaymentModal">
                  <div className="loaderDiv">
                    {/* <Loader
                      type="Oval"
                      color="#4E57AA"
                      height={100}
                      width={100}
                      timeout={30000} //3 secs
                    /> */}
                    <img className="logoImageSpinnerGif" src={LogoSpinner}></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default withRouter(ChangeServiceCheckoutModal);